import { render, staticRenderFns } from "./MobileAppDeveloper.vue?vue&type=template&id=5a4c7d2b&scoped=true&"
import script from "./MobileAppDeveloper.vue?vue&type=script&lang=js&"
export * from "./MobileAppDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./MobileAppDeveloper.vue?vue&type=style&index=0&id=5a4c7d2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c7d2b",
  null
  
)

export default component.exports